import { WebShareApiSettings } from './types/web-share-api-settings';

const canUseWebShareApi = (shareSettings: WebShareApiSettings) =>
  typeof navigator !== 'undefined' &&
  typeof navigator.share === 'function' &&
  navigator.canShare?.(shareSettings);

const handleWebShare = (shareSettings: WebShareApiSettings) => {
  try {
    navigator.share(shareSettings);
  } catch (error) {
    console.error('Error sharing:', error);
  }
};

// Strip any [placeholder] content left in accidentally, along with the square brackets
const removePlaceholders = (text: string) => text.replace(/\[[^\]]*\]/g, '');

const getWebShareSettings = (): WebShareApiSettings => {
  const textElement = document.querySelector('.ia-share-mobile-text');
  const titleElement = document.querySelector('.ia-share-mobile-title');
  const urlElement = document.querySelector('.ia-share-mobile-url');

  const currentPageUrl = new URL(window.location.href);
  // Replace page number after final slash with 1
  const actionUrlPage1 = currentPageUrl.href.replace(/\/([^/]*)$/, '/1');

  return {
    text: removePlaceholders(textElement?.textContent || '')
      .replace(/\n/g, '')
      .trim(),
    title: removePlaceholders(titleElement?.textContent || '')
      .replace(/\n/g, '')
      .trim(),
    url:
      removePlaceholders(urlElement?.textContent || '')
        .replace(/\n/g, '')
        .trim() || actionUrlPage1,
  };
};

const isDeviceThatUsesApps = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const mobileShareButton = () => {
  const shareButtonsContainer = document.querySelector('.en__socialShares');
  if (!shareButtonsContainer) return;

  const webShareSettings = getWebShareSettings();

  const useMobileShareButton = isDeviceThatUsesApps && canUseWebShareApi(webShareSettings);

  if (!useMobileShareButton) {
    // Make sure built-in EN share buttons are visible if we're not using the mobile share button (e.g. on desktop)
    const enShareButtons = document.querySelectorAll('.en__socialShare');
    enShareButtons.forEach((button) => ((button as HTMLElement).style.display = 'block'));

    return;
  }

  shareButtonsContainer.classList.add('ia-share-mobile-show');

  shareButtonsContainer.insertAdjacentHTML(
    'beforeend',
    `<button aria-label='Share this page' class='ia-share-mobile-button' title='Share this page' type='button'>Share</button>`,
  );

  const mobileShareButton = shareButtonsContainer.querySelector('.ia-share-mobile-button');
  mobileShareButton?.addEventListener('click', () => handleWebShare(webShareSettings));
};
